module.exports = __webpack_public_path__ + "img/radi8-newsfeed.0cb36a54.png";